import { useMemo } from 'react'
import { DisplayPriceGettingParams } from '../../../../../../../baseComponents/Displays/DisplayPrice'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { getISOCurrencyMain } from '../../../../../../../utils/reducers/getters'
import { getCurrencySymbol } from '../../../../../../../utils/globals/price'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'

interface CustomDetailsTextFieldTPVProps {
    data: string
    label?: string
    className?: string
}

export const CustomDetailsTextFieldTPV: React.FC<CustomDetailsTextFieldTPVProps> = ({ className, data, label }) => {
    return (
        <div className='flex flex-row gap-x-8 w-full '>
            {label ? <span className='overflow-hidden '>{label}</span> : null}
            <span className={'overflow-hidden ' + (className || '')} >{data}</span>
        </div>
    )
}

interface CustomDisplayProductPriceTPVProps {
    price: string
    discountPrice?: string
    className?: string
    discountClassName?: string
}

export const CustomDisplayProductPriceTPV: React.FC<CustomDisplayProductPriceTPVProps> = ({ price, discountPrice, className, discountClassName }) => {
    const currency = getISOCurrencyMain()
    const priceStatusClassName = discountPrice ? 'text-gray-9D line-through ' : 'light14 text-gray-51 '
    return (
        <div className='flex flex-wrap gap-x-8 gap-y-4 items-end price_box_parent '>
            { discountPrice ?
                <div className={'text-green-21 ' + discountClassName}><DisplayPriceGettingParams CurrencyId={currency} value={parseFloat(discountPrice)} with_vat={false}/></div>
                : null
            }
            <div className={priceStatusClassName + (className || '')}><DisplayPriceGettingParams CurrencyId={currency} value={parseFloat(price)} with_vat={false}/></div>
        </div>
    )
}

interface CustomDisplayProductImageTPVProps extends CustomDiscountTagTPVProps {
    url: string
    id: string
    name: string
    outOfStock: boolean
    typeDiscount: number
    CurrencyId: string
}

export const CustomDisplayProductImageTPV: React.FC<CustomDisplayProductImageTPVProps> = ({ url, id, discount, outOfStock, name, typeDiscount, CurrencyId }) => {
    return (
        <div className='relative flex flex-auto w-1 justify-center items-center product_image_parent'>
            <img src={url || '/no-image-small.png'} alt={name || 'product_image'} className='object-cover flex items-center justify-center product_image' data-tooltip-id={'product_image_' + id} />
            {discount && !outOfStock ? <CustomDiscountTagTPV discount={discount} typeDiscount={typeDiscount} CurrencyId={CurrencyId} /> : null}
            {outOfStock ? <CustomOutOfStockTagTPV /> : null}
        </div>
    )
}

interface CustomDiscountTagTPVProps {
    discount: string
    typeDiscount: number
    CurrencyId: string
}

const CustomDiscountTagTPV: React.FC<CustomDiscountTagTPVProps> = ({ discount, typeDiscount, CurrencyId }) => {
    const typeDiscountDict: TwinDictionary = useMemo(() => { return  {0: { name: '%' }, 1: { name: getCurrencySymbol(CurrencyId) }, 2: { name: getCurrencySymbol(CurrencyId) + ' /u' } } }, [CurrencyId]) 
    return (
        <div className='flex absolute h-40 bg-green-43 text-white p-10 items-center justify-center product_discount_price'>{'-' + discount + typeDiscountDict?.[typeDiscount]?.name}</div>
    )
}

interface CustomOutOfStockTagTPVProps {}

const CustomOutOfStockTagTPV: React.FC<CustomOutOfStockTagTPVProps> = () => {
    return (
        <div className='flex absolute w-80 h-35 bg-red-F0 text-white p-10 items-center rounded-md justify-center out_of_stock_product_tag'><TwinTrans transKey={'outOfStock'}>Agotado</TwinTrans></div>
    )
}
